import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserDTO } from 'BaseDataTypes';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  PlantDetailDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import {
  dialogData,
  genericDialogComponent,
} from 'projects/Assets/src/assets-base/Dialogs/genericDialog';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from 'src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from 'src/app/buttons/delete-button/delete-button.component';

@Component({
  selector: 'app-plant-dialog',
  imports: [
    dialogInputTitleComponent,
    FormsModule,
    SaveButtonComponent,
    DeleteButtonComponent,
  ],
  templateUrl: './plant-dialog.component.html',
  styleUrls: [
    './plant-dialog.component.css',
    '../../../../../../src/app/general-styles/dialogs.css',
  ],
})
export class PlantDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<PlantDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() plantRequest!: PlantDetailDTO;

  currentUser = this.userService.currentUser;

  clients: ClientSummaryDTO[] = [];
  users: UserDTO[] = [];
  constructor(
    public override dialogRef: MatDialogRef<PlantDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.plantRequest = this.data.data[0];
    if (this.plantRequest.processEngineerId == undefined)
      this.plantRequest.processEngineerId = null;
    if (this.plantRequest.projectManagerId == undefined)
      this.plantRequest.projectManagerId = null;
    if (this.plantRequest.plcEngineerId == undefined)
      this.plantRequest.plcEngineerId = null;
  }

  ngOnInit(): void {
    this.mainService.getAll<ClientSummaryDTO>('Client').subscribe((result) => {
      this.clients = result;
    });
    this.userService.getUserDTOs().subscribe((result) => {
      this.users = result;
    });
  }
  saveChanges() {
    if (this.plantRequest.id == 0) {
      this.mainService
        .add<PlantDetailDTO, PlantSummaryDTO>('Plant', this.plantRequest)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<PlantDetailDTO, PlantSummaryDTO>('Plant', this.plantRequest)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette anlægget?'")) {
      return;
    }
    this.mainService
      .delete('Plant', this.plantRequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
